/**
 * @generated SignedSource<<dac89e09c4af20be2f6a7cca8bb0a6db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventColor = "CALENDAR" | "GREEN" | "GREY" | "PEACH" | "PROVIDER" | "PURPLE" | "RED" | "ROYAL" | "YELLOW";
export type EventEditType = "ALL" | "FOLLOWING" | "THIS";
export type ColorPickerMutation$variables = {
  calendarId: string;
  editType: EventEditType;
  eventColor: EventColor;
  guid: string;
};
export type ColorPickerMutation$data = {
  readonly changeEventColor: {
    readonly event: {
      readonly color: string | null;
      readonly fellowColor: EventColor;
      readonly guid: string;
      readonly id: string;
    } | null;
  } | null;
};
export type ColorPickerMutation = {
  response: ColorPickerMutation$data;
  variables: ColorPickerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "calendarId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventColor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
      },
      {
        "kind": "Variable",
        "name": "editType",
        "variableName": "editType"
      },
      {
        "kind": "Variable",
        "name": "eventColor",
        "variableName": "eventColor"
      },
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "guid"
      }
    ],
    "concreteType": "ChangeEventColor",
    "kind": "LinkedField",
    "name": "changeEventColor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fellowColor",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ColorPickerMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ColorPickerMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a113459f0bc873612e32c057a74714cb",
    "id": null,
    "metadata": {},
    "name": "ColorPickerMutation",
    "operationKind": "mutation",
    "text": "mutation ColorPickerMutation(\n  $calendarId: ID!\n  $guid: String!\n  $eventColor: EventColor!\n  $editType: EventEditType!\n) {\n  changeEventColor(calendarId: $calendarId, guid: $guid, eventColor: $eventColor, editType: $editType) {\n    event {\n      id\n      guid\n      color\n      fellowColor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b954b88ba858cb39f568d32e5cc8f229";

export default node;
